// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"6aaa63e9","596":"e0dc2a44","664":"dcbe4499","834":"a491bf78","873":"2c61de09"}[chunkId] + ".chunk.js";
};